import styled from "styled-components";
import { theme } from "@themes";

export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const ContentWrapper = styled.div`
  margin: 1.5rem;
  width: 96.5%;
  box-shadow: 0px 2px 4px ${({ theme }) => theme.shadows.light};
  border-radius: 5px;
  background-color: ${({ theme }) => theme.neutral.white};
`;
